import GroupSelectors from './selectors';

export default GroupSelectors;
